import { useAppData } from "src/store/app-data"

export function usePermission() {
  const permissions = useAppData((state) => state.permissions) ?? []

  function hasPermission(slug) {
    return permissions.includes(slug)
  }

  function hasAnyPermission(slugs) {
    return slugs.some((slug) => permissions.includes(slug))
  }

  return { hasPermission, hasAnyPermission, permissions }
}
